import type { MouseEvent } from 'react';
import { getLocalePath } from '@/i18n/urls';
import type { Locale } from '@/i18n/routing';

export function categoryHref(locale: Locale | string, slug: string) {
  return getLocalePath(locale, `/categories/${slug}`);
}

/** Ctrl/Cmd/Shift/Alt and non-primary buttons should follow the real href. */
export function isModifiedClick(event: MouseEvent) {
  return (
    event.metaKey ||
    event.ctrlKey ||
    event.shiftKey ||
    event.altKey ||
    event.button !== 0
  );
}

export function rememberCategoryHash(slug: string) {
  window.history.replaceState(null, '', `#${slug}`);
}
